import superagent from 'superagent';
import tokenFormatter from '../formatters/token.formatter';

export const JWT_KEY = 'ngStorage-tokenJWT';
const storedToken = localStorage.getItem(JWT_KEY) || sessionStorage.getItem(JWT_KEY);

const linkUserWithHospital = (hospitalId, userId, roleId) =>
  superagent
    .post(`${CONFIG.BASE_URL_V4}/hospitals/${hospitalId}/${roleId}`)
    .set('Authorization', `JWT ${tokenFormatter.format(storedToken)}`)
    .query({ hospitalId, roleId, userId });

const getUserSuggestion = text =>
  superagent
    .get(`${CONFIG.BASE_URL_V4}/users/suggestions`)
    .set('Authorization', `JWT ${tokenFormatter.format(storedToken)}`)
    .query({ text });

const createUser = (hospitalId, email, username, firstName, lastName, sendWelcomeEmail, role) =>
  superagent
    .post(`${CONFIG.BASE_URL_V4}/users`)
    .set('Authorization', `JWT ${tokenFormatter.format(storedToken)}`)
    .send({
      generatePassword: true,
      sendWelcomeEmail,
      sendPassword: true,
      username,
      firstName,
      lastName,
      roles: ['user'],
      [role === 'members' ? 'hospitalMemberships' : 'hospitalsAdministered']: [hospitalId],
      email,
    });

export default {
  linkUserWithHospital,
  getUserSuggestion,
  createUser,
};



// WEBPACK FOOTER //
// ./src/services/api.js